var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33183 4.50063L11.9985 7.1673M1.66516 14.834L1.91586 12.5777C1.94648 12.3021 1.9618 12.1642 2.0035 12.0354C2.0405 11.9211 2.09278 11.8124 2.15892 11.7121C2.23346 11.599 2.33152 11.501 2.52764 11.3048L11.3318 2.50064C12.0682 1.76425 13.2621 1.76425 13.9985 2.50063C14.7349 3.23701 14.7349 4.43092 13.9985 5.1673L5.19431 13.9715C4.99819 14.1676 4.90013 14.2657 4.78709 14.3402C4.68679 14.4064 4.57802 14.4586 4.46373 14.4956C4.3349 14.5373 4.19707 14.5527 3.9214 14.5833L1.66516 14.834Z",
    stroke: "#4F5B6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit020);
export default __webpack_public_path__ + "static/media/edit-020.5bc244d1e2db3a82a46a98b38314f04c.svg";
export { ForwardRef as ReactComponent };